module.exports = __webpack_public_path__ + "img/00008.564b82f0.webp";